"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const teal = {
    100: "#323f35",
    90: "#415546",
    80: "#4c6551",
    70: "#577667",
    60: "#648881",
    50: "#719b9d",
    40: "#86b1b3",
    30: "#9cc7c9",
    20: "#b1dcde",
    10: "#d3ecee",
    0: "#e4f4f5",
};
exports.default = teal;
//# sourceMappingURL=teal.js.map